import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { ThemeProvider, Tooltip } from "@mui/material";
import { pageTheme } from "../../../ayudas/Themes";
import React, { useEffect, useState } from "react";
import {
  ControlCameraRounded,
  Description,
  ExitToApp,
  FeedRounded,
  SettingsSuggestRounded,
  Upcoming,
} from "@mui/icons-material";
import { env2 } from "../../../ayudas/Instance";
import "./Drawner.scss";
import { env } from "../../../env";

export default function CollapseList(props) {
  const { DataUser, ExternalOpen, pageExternal } = props;
  const [openListOne, setOpenListOne] = useState(true);
  const [openListTwo, setOpenListTwo] = useState(true);
  const [openListThree, setOpenListThree] = useState(true);
  const [Page, setPage] = useState(pageExternal);

  useEffect(() => {
    setPage(pageExternal);
  }, [pageExternal]);

  const handleCollapseOne = () => {
    setOpenListOne(!openListOne);
  };
  const handleCollapseTwo = () => {
    setOpenListTwo(!openListTwo);
  };
  const handleCollapseThree = () => {
    setOpenListThree(!openListThree);
  };
  const HandlePage = (page) => {
    setPage(page);
    props.pageSeleted(page);
  };
  const goUrl = (url) => {
    var a = document.createElement("a");
    a.target = "_blank";
    a.href = url;
    a.click();
  };

  const Logout = () => {
    props.Logout();
  };

  const disablesPages = (page) => {
    let pagesEnvDisabled = env.REACT_APP_DISABLED_PAGES.split(",");

    if (pagesEnvDisabled.indexOf(page) !== -1) {
      return true;
    }
    return false;
  };
  return (
    <ThemeProvider theme={pageTheme}>
      <List
        sx={{
          width: "100%",
          maxWidth: 360,
          overflow: "auto",
          "& .MuiListItemButton-root:hover": {
            backgroundColor: "rgba(255,255,255,.05) !important",
          },
        }}
        component="nav"
        aria-labelledby="nested-list-subheader"
        className="MenuNavBar"
      >
        <ListItemButton
          style={{ backgroundColor: Page === 0 ? "#544628" : "#090f1a" }}
          key={"Dashboard"}
          disabled={disablesPages("Dashboard")}
          onClick={() => {
            HandlePage(0);
          }}
        >
          <Tooltip title="Dashboard">
            <ListItemIcon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
              >
                <path
                  d="M14 2.33325C11.7518 2.33331 9.55158 2.98292 7.66391 4.20393C5.77623 5.42495 4.28154 7.16536 3.35965 9.2158C2.43775 11.2662 2.12792 13.5394 2.46742 15.7617C2.80692 17.9841 3.7813 20.0611 5.27333 21.7427C5.38236 21.8654 5.51603 21.9637 5.66561 22.0312C5.81519 22.0987 5.97733 22.134 6.14144 22.1346C16.1002 22.1748 11.63 22.1661 21.83 22.1631C21.994 22.1632 22.1563 22.1287 22.3061 22.0617C22.4559 21.9947 22.5899 21.8969 22.6992 21.7746C24.1999 20.0956 25.1826 18.0182 25.5287 15.7931C25.8748 13.568 25.5696 11.2903 24.6498 9.23482C23.7301 7.17935 22.2351 5.43398 20.3454 4.20934C18.4556 2.9847 16.2519 2.33313 14 2.33325ZM19.3559 11.441L17.3166 12.9343C17.4333 13.2777 17.4952 13.6373 17.5 13.9999C17.5032 14.7826 17.2451 15.544 16.7666 16.1633C16.2881 16.7827 15.6165 17.2246 14.8583 17.419C14.1001 17.6133 13.2988 17.5491 12.5813 17.2364C11.8638 16.9237 11.2712 16.3804 10.8974 15.6927C10.5237 15.005 10.3902 14.2123 10.5181 13.4401C10.646 12.6679 11.028 11.9606 11.6035 11.4301C12.1791 10.8997 12.9152 10.5765 13.6952 10.5119C14.4752 10.4473 15.2545 10.6449 15.9095 11.0733L17.9774 9.55877C18.2273 9.382 18.5366 9.31051 18.8387 9.35972C19.1409 9.40894 19.4115 9.57491 19.5924 9.82185C19.7732 10.0688 19.8498 10.3769 19.8056 10.6798C19.7614 10.9827 19.5999 11.256 19.3559 11.441Z"
                  fill={Page === 0 ? "#fff" : "#fff"}
                />
                <path
                  d="M14 15.1666C14.6443 15.1666 15.1667 14.6443 15.1667 13.9999C15.1667 13.3556 14.6443 12.8333 14 12.8333C13.3556 12.8333 12.8333 13.3556 12.8333 13.9999C12.8333 14.6443 13.3556 15.1666 14 15.1666Z"
                  fill={Page === 0 ? "#fff" : "#fff"}
                />
              </svg>
            </ListItemIcon>
          </Tooltip>

          <ListItemText
            style={{ color: Page === 0 ? "#fff" : "#fff" }}
            primary={"Dashboard"}
          />
        </ListItemButton>
        <ListItemButton onClick={handleCollapseOne}>
          <ListItemIcon>
            <Tooltip title="Emulation Control">
              <ControlCameraRounded />
            </Tooltip>
          </ListItemIcon>
          <ListItemText
            primary={ExternalOpen ? "Emulation Control" : ""}
            style={{ color: "#fff", marginLeft: "-25px" }}
          />
          {openListOne ? (
            <ExpandLess style={{ fill: "#fff" }} />
          ) : (
            <ExpandMore style={{ fill: "#fff" }} />
          )}
        </ListItemButton>
        <Collapse in={openListOne} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton
              sx={{ pl: ExternalOpen ? 4 : 2 }}
              style={{
                backgroundColor: Page === 4 ? "#544628" : "#090f1a",
              }}
              key={"Endpoints"}
              onClick={() => {
                HandlePage(4);
              }}
              disabled={disablesPages("Endpoints")}
            >
              <Tooltip title="Endpoints">
                <ListItemIcon>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                  >
                    <path
                      d="M26.25 24.5H1.74999C1.48749 24.5 1.13749 24.325 0.962488 24.0625C0.787488 23.8 0.787488 23.45 0.962488 23.1875L2.71249 20.5625C2.88749 20.3 3.14999 20.125 3.49999 20.125H24.5C24.85 20.125 25.1125 20.3 25.2875 20.65L27.0375 23.275C27.2125 23.5375 27.125 23.8875 27.0375 24.15C26.8625 24.325 26.5125 24.5 26.25 24.5Z"
                      fill={Page === 4 ? "#fff" : "#fff"}
                    />
                    <path
                      d="M23.625 4.375H4.375C3.85 4.375 3.5 4.725 3.5 5.25V17.5C3.5 18.025 3.85 18.375 4.375 18.375H23.625C24.15 18.375 24.5 18.025 24.5 17.5V5.25C24.5 4.725 24.15 4.375 23.625 4.375ZM10.2375 13.3875C10.5875 13.7375 10.5875 14.2625 10.2375 14.6125C10.0625 14.7875 9.8875 14.875 9.625 14.875C9.3625 14.875 9.1875 14.7875 9.0125 14.6125L6.3875 11.9875C6.0375 11.6375 6.0375 11.1125 6.3875 10.7625L9.0125 8.1375C9.3625 7.7875 9.8875 7.7875 10.2375 8.1375C10.5875 8.4875 10.5875 9.0125 10.2375 9.3625L8.225 11.375L10.2375 13.3875ZM16.5375 8.225L13.0375 15.225C12.8625 15.575 12.6 15.75 12.25 15.75C12.075 15.75 11.9875 15.75 11.9 15.6625C11.4625 15.4875 11.2875 14.9625 11.55 14.525L15.05 7.525C15.225 7.0875 15.75 6.9125 16.1875 7.175C16.5375 7.35 16.7125 7.875 16.5375 8.225ZM21.6125 11.9875L18.9875 14.6125C18.8125 14.7875 18.6375 14.875 18.375 14.875C18.1125 14.875 17.9375 14.7875 17.7625 14.6125C17.4125 14.2625 17.4125 13.7375 17.7625 13.3875L19.775 11.375L17.7625 9.3625C17.4125 9.0125 17.4125 8.4875 17.7625 8.1375C18.1125 7.7875 18.6375 7.7875 18.9875 8.1375L21.6125 10.7625C21.9625 11.1125 21.9625 11.6375 21.6125 11.9875Z"
                      fill={Page === 4 ? "#fff" : "#fff"}
                    />
                    <rect
                      x="5"
                      y="6"
                      width="17"
                      height="11"
                      fill={Page === 4 ? "#fff" : "#fff"}
                    />
                  </svg>
                </ListItemIcon>
              </Tooltip>
              <ListItemText
                style={{ color: Page === 4 ? "#fff" : "#fff" }}
                primary={"Endpoints"}
              />
            </ListItemButton>
            <ListItemButton
              sx={{ pl: ExternalOpen ? 4 : 2 }}
              style={{
                backgroundColor: Page === 2 ? "#544628" : "#090f1a",
              }}
              key={"Artifacts"}
              onClick={() => {
                HandlePage(2);
              }}
              disabled={disablesPages("Threats")}
            >
              <Tooltip title="Threat Library">
                <ListItemIcon>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                  >
                    <path
                      d="M17.5 2.2749V6.9999H22.225L17.5 2.2749Z"
                      fill={Page === 2 ? "#fff" : "#fff"}
                    />
                    <path
                      d="M20.5625 8.75H16.625C16.1 8.75 15.75 8.4 15.75 7.875V1.75H6.125C5.6 1.75 5.25 2.1 5.25 2.625V25.375C5.25 25.9 5.6 26.25 6.125 26.25H21.875C22.4 26.25 22.75 25.9 22.75 25.375V10.9375C22.75 9.7125 21.7875 8.75 20.5625 8.75ZM10.4125 18.725C10.4125 18.8125 10.325 18.9 10.2375 18.9875C10.15 19.075 10.0625 19.1625 9.975 19.1625C9.8875 19.25 9.7125 19.25 9.625 19.25C9.5375 19.25 9.5375 19.25 9.45 19.25C9.3625 19.25 9.3625 19.25 9.275 19.1625C9.1875 19.1625 9.1875 19.075 9.1 19.075L9.0125 18.9875C8.925 18.9 8.8375 18.8125 8.8375 18.725C8.8375 18.6375 8.75 18.4625 8.75 18.375C8.75 18.2875 8.75 18.2875 8.75 18.2C8.75 18.1125 8.75 18.1125 8.8375 18.025C8.8375 17.9375 8.8375 17.9375 8.925 17.85C8.925 17.7625 9.0125 17.7625 9.0125 17.7625L9.1 17.675C9.1875 17.675 9.1875 17.5875 9.275 17.5875C9.3625 17.5875 9.3625 17.5875 9.45 17.5C9.7125 17.4125 10.0625 17.5 10.2375 17.7625L10.325 17.85C10.325 17.9375 10.4125 17.9375 10.4125 18.025C10.4125 18.1125 10.4125 18.1125 10.5 18.2C10.5 18.2875 10.5 18.2875 10.5 18.375C10.5 18.4625 10.5 18.6375 10.4125 18.725ZM10.4125 15.225C10.4125 15.3125 10.325 15.4 10.2375 15.4875C10.15 15.575 10.0625 15.6625 9.975 15.6625C9.8875 15.75 9.7125 15.75 9.625 15.75C9.5375 15.75 9.5375 15.75 9.45 15.75C9.3625 15.75 9.3625 15.75 9.275 15.6625C9.1875 15.6625 9.1875 15.575 9.1 15.575L9.0125 15.4875C8.925 15.4 8.8375 15.3125 8.8375 15.225C8.8375 15.1375 8.75 14.9625 8.75 14.875C8.75 14.7875 8.75 14.6125 8.8375 14.525C8.8375 14.4375 8.925 14.35 9.0125 14.2625C9.275 14 9.625 13.9125 9.975 14.0875C10.0625 14.175 10.15 14.175 10.2375 14.2625C10.325 14.35 10.4125 14.4375 10.4125 14.525C10.4125 14.6125 10.5 14.7875 10.5 14.875C10.5 14.9625 10.5 15.1375 10.4125 15.225ZM10.2375 11.9875C10.15 12.075 10.0625 12.1625 9.975 12.1625C9.8875 12.25 9.7125 12.25 9.625 12.25C9.3625 12.25 9.1875 12.1625 9.0125 11.9875C8.8375 11.8125 8.75 11.6375 8.75 11.375C8.75 11.1125 8.8375 10.9375 9.0125 10.7625L9.1 10.675C9.1875 10.675 9.1875 10.5875 9.275 10.5875C9.3625 10.5875 9.3625 10.5875 9.45 10.5C9.625 10.5 9.8 10.5 9.975 10.5875C10.0625 10.675 10.15 10.675 10.2375 10.7625C10.4125 10.9375 10.5 11.1125 10.5 11.375C10.5 11.6375 10.4125 11.8125 10.2375 11.9875ZM18.375 19.25H12.25C11.725 19.25 11.375 18.9 11.375 18.375C11.375 17.85 11.725 17.5 12.25 17.5H18.375C18.9 17.5 19.25 17.85 19.25 18.375C19.25 18.9 18.9 19.25 18.375 19.25ZM18.375 15.75H12.25C11.725 15.75 11.375 15.4 11.375 14.875C11.375 14.35 11.725 14 12.25 14H18.375C18.9 14 19.25 14.35 19.25 14.875C19.25 15.4 18.9 15.75 18.375 15.75ZM18.375 12.25H12.25C11.725 12.25 11.375 11.9 11.375 11.375C11.375 10.85 11.725 10.5 12.25 10.5H18.375C18.9 10.5 19.25 10.85 19.25 11.375C19.25 11.9 18.9 12.25 18.375 12.25Z"
                      fill={Page === 2 ? "#fff" : "#fff"}
                    />
                  </svg>
                </ListItemIcon>
              </Tooltip>
              <ListItemText
                style={{ color: Page === 2 ? "#fff" : "#fff" }}
                primary={"Threat Library"}
              />
            </ListItemButton>
            <ListItemButton
              sx={{ pl: ExternalOpen ? 4 : 2 }}
              style={{
                backgroundColor: Page === 5 ? "#544628" : "#090f1a",
              }}
              key={"Packages"}
              onClick={() => {
                HandlePage(5);
              }}
              disabled={disablesPages("Packages")}
            >
              <Tooltip title="Packages">
                <ListItemIcon>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="20"
                    viewBox="0 0 25 20"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M10.7375 0.7375C10.2625 0.2625 9.625 0 8.9625 0H2.5C1.125 0 0.0125 1.125 0.0125 2.5L0 17.5C0 18.875 1.125 20 2.5 20H22.5C23.875 20 25 18.875 25 17.5V5C25 3.625 23.875 2.5 22.5 2.5H12.5L10.7375 0.7375Z"
                      fill={Page === 5 ? "#fff" : "#fff"}
                    />
                  </svg>
                </ListItemIcon>
              </Tooltip>
              <ListItemText
                style={{ color: Page === 5 ? "#fff" : "#fff" }}
                primary={"Packages"}
              />
            </ListItemButton>
            <ListItemButton
              sx={{ pl: ExternalOpen ? 4 : 2 }}
              style={{
                backgroundColor:
                  Page === 6 || Page === 66 ? "#544628" : "#090f1a",
              }}
              key={"Emulations"}
              onClick={() => {
                HandlePage(6);
              }}
              disabled={disablesPages("Emulations")}
            >
              <Tooltip title="Emulations">
                <ListItemIcon>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                  >
                    <path
                      d="M19.057 12.4075C18.8336 12.3751 18.6204 12.2926 18.4333 12.1664C18.2462 12.0401 18.09 11.8733 17.9763 11.6783C17.8626 11.4833 17.7944 11.2651 17.7767 11.0401C17.759 10.8151 17.7923 10.589 17.8741 10.3786C17.9261 10.2411 17.9337 10.0907 17.896 9.94859C17.8582 9.80648 17.7769 9.67975 17.6635 9.58617C17.1628 9.16571 16.5929 8.83542 15.9791 8.61C15.8394 8.55808 15.6868 8.5516 15.5432 8.59146C15.3995 8.63133 15.2721 8.71552 15.1791 8.83203C15.0391 9.01105 14.8601 9.15585 14.6558 9.25543C14.4516 9.35501 14.2273 9.40676 14 9.40676C13.7727 9.40676 13.5485 9.35501 13.3442 9.25543C13.1399 9.15585 12.9609 9.01105 12.8209 8.83203C12.7279 8.71552 12.6005 8.63133 12.4569 8.59146C12.3132 8.5516 12.1606 8.55808 12.0209 8.61C11.4542 8.81811 10.9243 9.11534 10.4513 9.49047C10.3321 9.58486 10.2462 9.71494 10.2063 9.86166C10.1663 10.0084 10.1744 10.1641 10.2293 10.3059C10.3176 10.5218 10.3541 10.7554 10.3359 10.988C10.3176 11.2206 10.2451 11.4457 10.1241 11.6452C10.0031 11.8447 9.8371 12.0131 9.63931 12.1368C9.44152 12.2606 9.21748 12.3362 8.98516 12.3577C8.83434 12.3739 8.69268 12.438 8.58103 12.5407C8.46939 12.6434 8.39367 12.7792 8.36501 12.9281C8.29373 13.281 8.25782 13.64 8.25782 14C8.2573 14.3014 8.28162 14.6022 8.33056 14.8996C8.35491 15.0533 8.42922 15.1948 8.54201 15.302C8.6548 15.4093 8.79978 15.4764 8.95454 15.493C9.19196 15.5152 9.42059 15.5941 9.62129 15.7228C9.82199 15.8516 9.98892 16.0266 10.1081 16.2331C10.2273 16.4397 10.2953 16.6717 10.3064 16.9099C10.3175 17.1482 10.2714 17.3855 10.1719 17.6023C10.1068 17.7432 10.0906 17.9019 10.126 18.0531C10.1614 18.2043 10.2462 18.3393 10.3671 18.4368C10.8648 18.8496 11.4293 19.1746 12.0362 19.3977C12.1138 19.4245 12.1952 19.4388 12.2774 19.4398C12.39 19.4395 12.5009 19.4123 12.6008 19.3603C12.7007 19.3084 12.7867 19.2332 12.8516 19.1412C12.988 18.9424 13.1709 18.7799 13.3844 18.6678C13.5979 18.5557 13.8355 18.4975 14.0766 18.498C14.3102 18.4983 14.5405 18.5532 14.7492 18.6582C14.9579 18.7632 15.1392 18.9155 15.2786 19.1029C15.3714 19.2276 15.5028 19.3181 15.6523 19.3603C15.8019 19.4026 15.9612 19.3942 16.1055 19.3364C16.6604 19.1131 17.1771 18.8044 17.6367 18.4215C17.7522 18.326 17.8344 18.1964 17.8716 18.0513C17.9087 17.9061 17.8989 17.7529 17.8434 17.6137C17.7534 17.4006 17.7142 17.1694 17.7288 16.9385C17.7434 16.7076 17.8115 16.4832 17.9277 16.2831C18.0439 16.083 18.205 15.9126 18.3983 15.7855C18.5917 15.6583 18.8119 15.5778 19.0417 15.5504C19.1906 15.5298 19.3292 15.4623 19.4373 15.3577C19.5453 15.2531 19.6173 15.1168 19.6427 14.9685C19.7041 14.6492 19.7375 14.3251 19.7422 14C19.7423 13.6571 19.7102 13.3149 19.6465 12.9779C19.6206 12.8329 19.5498 12.6998 19.4439 12.5974C19.3381 12.495 19.2027 12.4285 19.057 12.4075ZM15.9141 14C15.9141 14.3786 15.8018 14.7486 15.5915 15.0634C15.3812 15.3782 15.0822 15.6235 14.7325 15.7684C14.3827 15.9132 13.9979 15.9511 13.6266 15.8773C13.2553 15.8034 12.9142 15.6211 12.6466 15.3534C12.3789 15.0858 12.1966 14.7447 12.1227 14.3734C12.0489 14.0021 12.0868 13.6173 12.2316 13.2675C12.3765 12.9178 12.6218 12.6188 12.9366 12.4085C13.2514 12.1982 13.6214 12.0859 14 12.0859C14.5077 12.0859 14.9945 12.2876 15.3535 12.6466C15.7124 13.0055 15.9141 13.4924 15.9141 14Z"
                      fill={Page === 6 || Page === 66 ? "#fff" : "#fff"}
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M14 4.66683C11.3145 4.66683 8.89655 5.85901 7.22549 7.76848C6.80117 8.25336 6.0641 8.30244 5.57922 7.87811C5.09434 7.45377 5.04526 6.71672 5.4696 6.23184C7.55834 3.84508 10.6042 2.3335 14 2.3335C20.2616 2.3335 25.3087 7.45429 25.4311 13.7655L25.9992 13.1845C26.4496 12.7238 27.1882 12.7155 27.649 13.166C28.1097 13.6164 28.1179 14.3551 27.6675 14.8158L25.1008 17.4408C24.8814 17.6652 24.5806 17.7918 24.2667 17.7918C23.9527 17.7918 23.6519 17.6652 23.4325 17.4408L20.8658 14.8158C20.4154 14.3551 20.4237 13.6164 20.8844 13.166C21.3451 12.7155 22.0837 12.7238 22.5342 13.1845L23.0971 13.7602C22.9728 8.69295 18.9237 4.66683 14 4.66683ZM3.73333 10.2085C4.04729 10.2085 4.34801 10.335 4.56751 10.5595L7.13418 13.1845C7.58464 13.6453 7.57634 14.3839 7.11564 14.8343C6.65493 15.2848 5.91629 15.2765 5.46582 14.8158L4.90294 14.2401C5.0272 19.3073 9.07626 23.3335 14 23.3335C16.6854 23.3335 19.1035 22.1413 20.7745 20.2318C21.1988 19.7469 21.9359 19.6979 22.4208 20.1222C22.9056 20.5466 22.9548 21.2837 22.5304 21.7685C20.4416 24.1553 17.3958 25.6668 14 25.6668C7.73838 25.6668 2.69128 20.546 2.56894 14.2348L2.00084 14.8158C1.55038 15.2765 0.811731 15.2848 0.35103 14.8343C-0.109672 14.3839 -0.117971 13.6453 0.332493 13.1845L2.89915 10.5595C3.11865 10.335 3.41937 10.2085 3.73333 10.2085Z"
                      fill={Page === 6 || Page === 66 ? "#fff" : "#fff"}
                    />
                  </svg>
                </ListItemIcon>
              </Tooltip>
              <ListItemText
                style={{
                  color: Page === 6 || Page === 66 ? "#fff" : "#fff",
                }}
                primary={"Emulations"}
              />
            </ListItemButton>
            <ListItemButton
              sx={{ pl: ExternalOpen ? 4 : 2 }}
              style={{
                backgroundColor: Page === 16 ? "#544628" : "#090f1a",
              }}
              key={"IoC Validation"}
              onClick={() => {
                HandlePage(16);
              }}
              disabled={disablesPages("IOC")}
            >
              <Tooltip title="IoC Validation">
                <ListItemIcon>
                  <Upcoming
                    style={{ fill: Page === 16 ? "#fff" : "#fff" }}
                  ></Upcoming>
                </ListItemIcon>
              </Tooltip>
              <ListItemText
                style={{ color: Page === 16 ? "#fff" : "#fff" }}
                primary={"IoC Validation"}
              />
            </ListItemButton>
            <ListItemButton
              sx={{ pl: ExternalOpen ? 4 : 2 }}
              style={{
                backgroundColor: Page === 17 ? "#544628" : "#090f1a",
                display: DataUser.user.result.rol !== "admin" ? "none" : "",
              }}
              key={"Scripts"}
              onClick={() => {
                HandlePage(17);
              }}
              disabled={disablesPages("Custom")}
            >
              <Tooltip title="Custom Threat Validation">
                <ListItemIcon>
                  <Description
                    style={{ fill: Page === 17 ? "#fff" : "#fff" }}
                  />
                </ListItemIcon>
              </Tooltip>
              <ListItemText
                style={{ color: Page === 17 ? "#fff" : "#fff" }}
                primary={"Custom Threat"}
              />
            </ListItemButton>
            <ListItemButton
              sx={{ pl: ExternalOpen ? 4 : 2 }}
              style={{
                backgroundColor: Page === 777 ? "#544628" : "#090f1a",
              }}
              key={"Incursion"}
              onClick={() => {
                HandlePage(777);
              }}
              disabled={disablesPages("Incursion") ||localStorage.getItem("UsrLevel")!=="admin"}
            >
              <Tooltip title="Incursion">
                <ListItemIcon>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M19.3334 19.3334H12.9167L15.3072 16.9417L11.6567 13.2901L13.3017 11.6451L16.9534 15.2956L19.3334 12.9167V19.3334ZM2.31169 19.3334L0.666687 17.6884L15.2967 3.04675L12.9167 0.666748H19.3334V7.08341L16.9534 4.70341L2.31285 19.3334H2.31169ZM6.69835 8.34341L0.666687 2.31175L2.31169 0.666748L8.35502 6.69841L6.69835 8.34225V8.34341Z"
                      fill={Page === 777 ? "#fff" : "#fff"}
                    />
                  </svg>
                </ListItemIcon>
              </Tooltip>
              <ListItemText
                style={{ color: Page === 777 ? "#fff" : "#fff" }}
                primary={"Incursion"}
              />
            </ListItemButton>
            {/* <ListItemButton
        key={"Waf validation"}
              onClick={goUrl.bind(this, "http://3.19.57.33:8008/")}
            >
              <Tooltip title="Waf validation">
                <ListItemIcon>
                  <FileDownload
                    style={{
                      fill: "#fff",
                      marginLeft: ExternalOpen ? "15px" : "0px",
                    }}
                  />
                </ListItemIcon>
              </Tooltip>
              <ListItemText
                style={{
                  color: "#fff",
                  marginLeft: ExternalOpen ? "15px" : "0px",
                }}
                primary={"Waf validation"}
              />
            </ListItemButton> */}
          </List>
        </Collapse>
        <ListItemButton onClick={handleCollapseTwo}>
          <ListItemIcon>
            <Tooltip title="Emulation Information">
              <FeedRounded />
            </Tooltip>
          </ListItemIcon>
          <ListItemText
            primary={ExternalOpen ? "Emulation Information" : ""}
            style={{ color: "#fff", marginLeft: "-25px" }}
          />
          {openListTwo ? (
            <ExpandLess style={{ fill: "#fff" }} />
          ) : (
            <ExpandMore style={{ fill: "#fff" }} />
          )}
        </ListItemButton>
        <Collapse in={openListTwo} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton
              sx={{ pl: ExternalOpen ? 4 : 2 }}
              style={{
                backgroundColor: Page === 9 ? "#544628" : "#090f1a",
              }}
              key={"Isolation Network"}
              onClick={() => {
                HandlePage(9);
              }}
              disabled={disablesPages("Isolation")}
            >
              <Tooltip title="Isolation Network">
                <ListItemIcon>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                  >
                    <path
                      d="M17.4697 0H7.08289V10.3868H17.4697V0Z"
                      fill={Page === 9 ? "#fff" : "#fff"}
                    />
                    <path
                      d="M5.98002 18.2026H0V24.1827H5.98002V18.2026Z"
                      fill={Page === 9 ? "#fff" : "#fff"}
                    />
                    <path
                      d="M15.1087 18.2026H9.12872V24.1827H15.1087V18.2026Z"
                      fill={Page === 9 ? "#fff" : "#fff"}
                    />
                    <path
                      d="M24 18.2026H18.02V24.1827H24V18.2026Z"
                      fill={Page === 9 ? "#fff" : "#fff"}
                    />
                    <path
                      d="M22.1916 13.693H12.8277V12.355H11.5673V13.693H1.81067V15.2662H2.12348V17.1545H3.38388V15.2662H11.5673V17.1545H12.8277V15.2662H20.8536V17.1545H22.1117V15.2662H22.1916V13.693Z"
                      fill={Page === 9 ? "#fff" : "#fff"}
                    />
                  </svg>
                </ListItemIcon>
              </Tooltip>
              <ListItemText
                style={{ color: Page === 9 ? "#fff" : "#fff" }}
                primary={"Isolation Network"}
              />
            </ListItemButton>
            <ListItemButton
              sx={{ pl: ExternalOpen ? 4 : 2 }}
              style={{
                backgroundColor: Page === 14 ? "#544628" : "#090f1a",
              }}
              key={"Agent Diagram"}
              onClick={() => {
                HandlePage(14);
              }}
              disabled={disablesPages("Diagram")}
            >
              <Tooltip title="Endpoints Diagram">
                <ListItemIcon>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                  >
                    <g clipPath="url(#clip0)">
                      <path
                        d="M15.9579 12.0417H27.944C27.5222 8.3015 24.8869 1.28974 15.9579 0V12.0417Z"
                        fill={Page === 14 ? "#fff" : "#fff"}
                      />
                      <path
                        d="M12.5419 1.53418C5.5979 1.93374 0.0559692 7.72123 0.0559692 14.778C0.0559692 22.0799 5.96767 28.0001 13.2472 28.0001C20.2708 28.0001 26.0203 22.5139 26.4166 15.4579H12.5419V1.53418Z"
                        fill={Page === 14 ? "#fff" : "#fff"}
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0">
                        <rect width="28" height="28" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </ListItemIcon>
              </Tooltip>
              <ListItemText
                style={{ color: Page === 14 ? "#fff" : "#fff" }}
                primary={"Endpoints Diagram"}
              />
            </ListItemButton>
          </List>
        </Collapse>
        <ListItemButton onClick={handleCollapseThree}>
          <ListItemIcon>
            <Tooltip title="System Configuration">
              <SettingsSuggestRounded />
            </Tooltip>
          </ListItemIcon>
          <ListItemText
            primary={ExternalOpen ? "System Configuration " : ""}
            style={{ color: "#fff", marginLeft: "-25px" }}
          />
          {openListThree ? (
            <ExpandLess style={{ fill: "#fff" }} />
          ) : (
            <ExpandMore style={{ fill: "#fff" }} />
          )}
        </ListItemButton>
        <Collapse in={openListThree} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {env.REACT_APP_INTERNAL_CRUD_USER === "true" && (
              <ListItemButton
                sx={{ pl: ExternalOpen ? 4 : 2 }}
                key={"Users"}
                onClick={() => {
                  HandlePage(1);
                }}
                disabled={disablesPages("Users")}
                style={{
                  backgroundColor: Page === 1 ? "#544628" : "#090f1a",
                  display: DataUser.user.result.rol !== "admin" ? "none" : "",
                }}
              >
                <Tooltip title="Users">
                  <ListItemIcon>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M4.79997 7.20016C5.68345 7.20016 6.43752 6.88778 7.06238 6.26274C7.68745 5.63775 8.00002 4.88348 8.00002 4.00017C8.00002 3.11695 7.68745 2.36268 7.06238 1.7376C6.43752 1.11261 5.68341 0.800049 4.79997 0.800049C3.91658 0.800049 3.16248 1.11261 2.53748 1.7376C1.91254 2.36268 1.59998 3.11678 1.59998 4.00017C1.59998 4.88365 1.91254 5.63775 2.53748 6.26274C3.16248 6.8876 3.91658 7.20016 4.79997 7.20016Z"
                        fill={Page === 1 ? "#fff" : "#fff"}
                      />
                      <path
                        d="M8.60623 12.1943C9.54374 13.1315 10.6749 13.6003 12 13.6003C13.3253 13.6003 14.4564 13.1315 15.3938 12.1943C16.3312 11.2565 16.8 10.1253 16.8 8.80034C16.8 7.47532 16.3312 6.34412 15.3938 5.40657C14.4564 4.46902 13.3253 4.00024 12 4.00024C10.6749 4.00024 9.54365 4.46911 8.60623 5.40657C7.66881 6.34399 7.19995 7.47519 7.19995 8.80034C7.19995 10.1255 7.66881 11.2566 8.60623 12.1943Z"
                        fill={Page === 1 ? "#fff" : "#fff"}
                      />
                      <path
                        d="M19.2003 7.20016C20.0834 7.20016 20.8376 6.88778 21.4626 6.26274C22.0875 5.63775 22.3999 4.88348 22.3999 4.00017C22.3999 3.11695 22.0875 2.36268 21.4626 1.7376C20.8377 1.11261 20.0834 0.800049 19.2003 0.800049C18.3166 0.800049 17.5626 1.11261 16.9376 1.7376C16.3128 2.36268 16.0002 3.11678 16.0002 4.00017C16.0002 4.88365 16.3128 5.63775 16.9376 6.26274C17.5626 6.8876 18.3166 7.20016 19.2003 7.20016Z"
                        fill={Page === 1 ? "#fff" : "#fff"}
                      />
                      <path
                        d="M22.4498 7.2002C22.4001 7.2002 22.2188 7.28772 21.9063 7.46271C21.594 7.6378 21.1876 7.8149 20.6877 7.9941C20.1879 8.17312 19.6918 8.26274 19.2003 8.26274C18.6418 8.26274 18.088 8.16699 17.5378 7.97523C17.5792 8.28341 17.6001 8.55849 17.6001 8.80017C17.6001 9.95851 17.2626 11.0251 16.5873 12.0002C17.9376 12.042 19.0415 12.5752 19.9002 13.6005H21.5751C22.2583 13.6005 22.8334 13.4314 23.3 13.0939C23.7665 12.7567 24 12.2627 24 11.6128C24.0001 8.67088 23.4837 7.20002 22.4498 7.2002Z"
                        fill={Page === 1 ? "#fff" : "#fff"}
                      />
                      <path
                        d="M20.5819 17.3066C20.4943 16.819 20.3838 16.3668 20.2504 15.9503C20.1171 15.5334 19.9379 15.1274 19.7132 14.7316C19.4881 14.336 19.2297 13.9983 18.938 13.719C18.6461 13.4397 18.2898 13.2171 17.8691 13.0502C17.4484 12.8836 16.9836 12.8003 16.4754 12.8003C16.3919 12.8003 16.2128 12.8899 15.9378 13.0691C15.6627 13.2481 15.3588 13.4485 15.0253 13.669C14.6919 13.8895 14.2465 14.0897 13.6878 14.2689C13.129 14.4481 12.5666 14.5377 12.0002 14.5377C11.4337 14.5377 10.8711 14.4481 10.3127 14.2689C9.75422 14.0897 9.30852 13.8895 8.97516 13.669C8.64172 13.4485 8.33765 13.2481 8.0627 13.0691C7.78761 12.8899 7.60855 12.8003 7.5251 12.8003C7.01683 12.8003 6.55226 12.8836 6.13138 13.0502C5.7105 13.2171 5.35429 13.4397 5.06266 13.719C4.77076 13.998 4.51266 14.336 4.28749 14.7316C4.06258 15.1274 3.88343 15.5334 3.75007 15.9503C3.61675 16.3668 3.50646 16.819 3.41881 17.3066C3.33124 17.7941 3.27297 18.2481 3.24381 18.6691C3.21461 19.09 3.20007 19.5214 3.20007 19.963C3.20007 20.9629 3.50414 21.7526 4.11245 22.3316C4.72098 22.9105 5.52937 23.2003 6.5375 23.2003H17.4627C18.4709 23.2003 19.2792 22.9105 19.8879 22.3316C20.4962 21.7526 20.8003 20.9629 20.8003 19.963C20.8003 19.5214 20.7857 19.0901 20.7569 18.6691C20.7273 18.2481 20.669 17.7941 20.5819 17.3066Z"
                        fill={Page === 1 ? "#fff" : "#fff"}
                      />
                      <path
                        d="M7.41244 12.0001C6.73741 11.0251 6.39998 9.9585 6.40011 8.80016C6.40011 8.55849 6.421 8.28358 6.46259 7.97522C5.91251 8.16686 5.35836 8.26274 4.80001 8.26274C4.30834 8.26274 3.81263 8.17316 3.31256 7.99409C2.81269 7.81489 2.40631 7.6378 2.09392 7.46271C1.78141 7.28772 1.60002 7.2002 1.55006 7.2002C0.516673 7.20024 0 8.67109 0 11.6128C0 12.2627 0.233359 12.7566 0.699945 13.0939C1.16666 13.4313 1.7417 13.6002 2.42483 13.6002H4.09993C4.95837 12.5752 6.06238 12.0419 7.41244 12.0001Z"
                        fill={Page === 1 ? "#fff" : "#fff"}
                      />
                    </svg>
                  </ListItemIcon>
                </Tooltip>
                <ListItemText
                  style={{ color: Page === 1 ? "#fff" : "#fff" }}
                  primary={"Users"}
                />
              </ListItemButton>
            )}
            <ListItemButton
              sx={{ pl: ExternalOpen ? 4 : 2 }}
              style={{
                display: DataUser.user.result.rol !== "admin" ? "none" : "",
                backgroundColor: Page === 7 ? "#544628" : "#090f1a",
              }}
              key={"Environment"}
              disabled={disablesPages("Environmets")}
              onClick={() => {
                HandlePage(7);
              }}
            >
              <Tooltip title="Environment Setup">
                <ListItemIcon>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="29"
                    height="28"
                    viewBox="0 0 29 28"
                    fill="none"
                  >
                    <path
                      d="M19.2749 8.33276C18.0163 8.63565 16.7172 8.81738 15.3778 8.85776V13.4414H19.9278C19.8874 11.5501 19.6518 9.83372 19.2749 8.33276Z"
                      fill={Page === 7 ? "#fff" : "#fff"}
                    />
                    <path
                      d="M15.3712 2.32202V7.83452C16.6163 7.79414 17.8279 7.6326 18.9923 7.34991C18.1106 4.56337 16.7375 2.7326 15.3712 2.32202Z"
                      fill={Page === 7 ? "#fff" : "#fff"}
                    />
                    <path
                      d="M10.599 7.34321C11.7769 7.6259 12.9952 7.79417 14.2471 7.83455V2.30859C12.8807 2.70571 11.4875 4.53648 10.599 7.34321Z"
                      fill={Page === 7 ? "#fff" : "#fff"}
                    />
                    <path
                      d="M23.1991 5.74815C21.6779 4.20007 19.7327 3.0693 17.5519 2.55103C18.5481 3.58083 19.3827 5.15584 19.9817 7.08084C21.1058 6.73757 22.1827 6.29334 23.1991 5.74815Z"
                      fill={Page === 7 ? "#fff" : "#fff"}
                    />
                    <path
                      d="M20.9577 13.4414H26.5644C26.4433 10.8299 25.4673 8.43372 23.9058 6.53564C22.7548 7.16834 21.5365 7.68661 20.2644 8.07026C20.675 9.68564 20.9173 11.5097 20.9577 13.4414Z"
                      fill={Page === 7 ? "#fff" : "#fff"}
                    />
                    <path
                      d="M9.66345 13.4413H14.2538V8.85766C12.901 8.81727 11.5885 8.63554 10.3231 8.32593C9.93941 9.82689 9.70384 11.55 9.66345 13.4413Z"
                      fill={Page === 7 ? "#fff" : "#fff"}
                    />
                    <path
                      d="M19.9279 14.5586H15.3712V19.1355C16.7106 19.1759 18.0163 19.3509 19.275 19.6605C19.6519 18.1663 19.8875 16.4432 19.9279 14.5586Z"
                      fill={Page === 7 ? "#fff" : "#fff"}
                    />
                    <path
                      d="M10.3231 19.6672C11.5885 19.3576 12.901 19.1759 14.2538 19.1355V14.5586H9.66345C9.70384 16.4499 9.93941 18.173 10.3231 19.6672Z"
                      fill={Page === 7 ? "#fff" : "#fff"}
                    />
                    <path
                      d="M14.2538 25.6847V20.1587C13.0019 20.1991 11.7769 20.3673 10.599 20.65C11.4875 23.4568 12.8807 25.2943 14.2538 25.6847Z"
                      fill={Page === 7 ? "#fff" : "#fff"}
                    />
                    <path
                      d="M17.5519 25.4491C19.7327 24.9241 21.6779 23.8001 23.2058 22.2453C22.1894 21.7001 21.1125 21.2559 19.9885 20.9126C19.3894 22.8443 18.5481 24.4126 17.5519 25.4491Z"
                      fill={Page === 7 ? "#fff" : "#fff"}
                    />
                    <path
                      d="M12.0326 2.56445C9.87206 3.08945 7.94033 4.2135 6.4259 5.75484C7.43552 6.29331 8.49898 6.73754 9.60956 7.07408C10.2086 5.15581 11.0432 3.59426 12.0326 2.56445Z"
                      fill={Page === 7 ? "#fff" : "#fff"}
                    />
                    <path
                      d="M20.2644 19.9297C21.5433 20.3134 22.7615 20.8317 23.9125 21.4644C25.474 19.5663 26.45 17.1701 26.5711 14.5586H20.9644C20.9173 16.4903 20.675 18.3076 20.2644 19.9297Z"
                      fill={Page === 7 ? "#fff" : "#fff"}
                    />
                    <path
                      d="M15.3712 20.1587V25.6779C16.7375 25.2673 18.1106 23.4366 18.9923 20.6433C17.8279 20.3606 16.6163 20.1991 15.3712 20.1587Z"
                      fill={Page === 7 ? "#fff" : "#fff"}
                    />
                    <path
                      d="M9.33361 8.06353C8.06823 7.67988 6.85669 7.16834 5.7192 6.53564C4.15766 8.43372 3.1817 10.8299 3.06055 13.4414H8.64035C8.674 11.503 8.92304 9.67891 9.33361 8.06353Z"
                      fill={Page === 7 ? "#fff" : "#fff"}
                    />
                    <path
                      d="M8.63358 14.5586H3.05377C3.17493 17.1701 4.15089 19.5663 5.71243 21.4644C6.84993 20.8384 8.06146 20.3201 9.32685 19.9365C8.923 18.3211 8.67396 16.4971 8.63358 14.5586Z"
                      fill={Page === 7 ? "#fff" : "#fff"}
                    />
                    <path
                      d="M6.41925 22.2452C7.93367 23.7865 9.8654 24.9105 12.0327 25.4355C11.0433 24.4057 10.2087 22.8375 9.60963 20.9192C8.49906 21.2625 7.42887 21.7067 6.41925 22.2452Z"
                      fill={Page === 7 ? "#fff" : "#fff"}
                    />
                  </svg>
                </ListItemIcon>
              </Tooltip>
              <ListItemText
                style={{ color: Page === 7 ? "#fff" : "#fff" }}
                primary={"Environment Setup"}
              />
            </ListItemButton>
            <ListItemButton
              sx={{ pl: ExternalOpen ? 4 : 2 }}
              key={"Health"}
              disabled={disablesPages("Health")}
              onClick={goUrl.bind(this, env2.health)}
            >
              <Tooltip title="Health">
                <ListItemIcon>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="30"
                    viewBox="0 0 24 30"
                    fill="none"
                  >
                    <path
                      d="M9.87502 16.4166H6.33335V12.1666H9.87502V8.62492H14.125V12.1666H17.6667V16.4166H14.125V19.9583H9.87502V16.4166ZM12 0.833252L0.666687 5.08325V13.7108C0.666687 20.8649 5.49752 27.5374 12 29.1666C18.5025 27.5374 23.3334 20.8649 23.3334 13.7108V5.08325L12 0.833252Z"
                      fill={Page === 785 ? "#fff" : "#fff"}
                    />
                  </svg>
                </ListItemIcon>
              </Tooltip>
              <ListItemText
                style={{ color: Page === 785 ? "#fff" : "#fff" }}
                primary={"Health"}
              />
            </ListItemButton>
            <ListItemButton
              style={{
                backgroundColor: Page === 13 ? "#544628" : "#090f1a",
              }}
              disabled={disablesPages("License")}
              key={"License"}
              onClick={() => {
                HandlePage(13);
              }}
            >
              <Tooltip title="License">
                <ListItemIcon>
                  <svg
                    width="24"
                    height="20"
                    viewBox="0 0 24 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M2.66665 19.3333H21.3333C22.5806 19.3706 23.6235 18.3929 23.6666 17.1458V2.8541C23.6242 1.60671 22.5809 0.628599 21.3333 0.666598H2.66665C1.41911 0.628599 0.375795 1.60671 0.333313 2.8541V17.1446C0.375799 18.3922 1.41891 19.3706 2.66665 19.3333ZM5 14.6667H13.6683C13.5823 13.7008 13.1252 12.8059 12.3932 12.17C11.5779 11.3612 10.4824 10.8974 9.33417 10.875C8.18595 10.8974 7.09046 11.3612 6.27517 12.17C5.5429 12.8058 5.08578 13.7008 5 14.6667ZM15.5 13.5H19V11.1667H15.5V13.5ZM7.66034 9.34052C8.10272 9.7829 8.70892 10.0217 9.33417 10C9.95941 10.0217 10.5656 9.7829 11.008 9.34052C11.4504 8.89813 11.6892 8.29193 11.6675 7.66669C11.6889 7.04154 11.4499 6.43554 11.0076 5.99324C10.5653 5.55094 9.95931 5.31197 9.33417 5.33335C8.70902 5.31197 8.10303 5.55094 7.66072 5.99324C7.21842 6.43554 6.97946 7.04154 7.00083 7.66669C6.97911 8.29193 7.21795 8.89813 7.66034 9.34052ZM14.3333 8.83335H19V6.50002H14.3333V8.83335Z"
                      fill={Page === 13 ? "#fff" : "#fff"}
                    />
                  </svg>
                </ListItemIcon>
              </Tooltip>
              <ListItemText
                style={{ color: Page === 13 ? "#fff" : "#fff" }}
                primary={"License"}
              />
            </ListItemButton>
          </List>
        </Collapse>
        <ListItemButton
          style={{ backgroundColor: Page === 10 ? "#544628" : "#090f1a" }}
          key={"Help"}
          disabled={disablesPages("Help")}
          onClick={() => {
            goUrl(
              "https://docs.epiphanysys.com/technical-documentation/admin-guides/e.v.e.-users-guide"
            );
          }}
        >
          <Tooltip title="Help">
            <ListItemIcon>
              <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M14 28C21.7323 28 28 21.7317 28 14C28 6.26828 21.7317 0 14 0C6.26828 0 0 6.26773 0 14C0 21.7323 6.26773 28 14 28ZM17.8626 11.8176C18.0669 11.424 18.1695 10.9856 18.1612 10.5423C18.1636 9.93915 17.9855 9.34911 17.6498 8.84805C17.2894 8.305 16.794 7.90742 16.2072 7.62852C15.5482 7.30969 14.8252 7.18555 14.0962 7.18555C13.3065 7.18555 12.5349 7.33484 11.8387 7.71437C11.2405 8.04031 10.7198 8.4789 10.3556 9.05804C10.0461 9.55133 9.84045 10.1004 9.84045 10.6877C9.84045 11.0131 9.98647 11.2893 10.209 11.5195C10.326 11.6428 10.4673 11.7405 10.6239 11.8064C10.7805 11.8723 10.9491 11.9049 11.119 11.9023C11.789 11.9023 12.1953 11.4648 12.3594 10.8452C12.4336 10.5748 12.5659 10.3239 12.7471 10.1099C12.9282 9.89587 13.1539 9.72392 13.4083 9.60601C13.8463 9.39656 14.3959 9.33257 14.8427 9.55132C15.2622 9.75531 15.4689 10.148 15.5356 10.5942C15.6078 11.0733 14.9155 11.7044 14.5955 11.9887C14.4179 12.1465 14.2374 12.2977 14.0563 12.4494C14.0233 12.477 13.9903 12.5046 13.9573 12.5323C13.7714 12.6832 13.5943 12.8446 13.4269 13.0158C13.1807 13.2839 12.9832 13.593 12.8433 13.9291C12.6787 14.3151 12.6202 14.7406 12.6202 15.1573C12.6202 15.515 12.7061 15.8628 12.9713 16.1166C13.2 16.3334 13.505 16.4513 13.8201 16.4447C14.4747 16.4447 14.8684 16.0777 14.9849 15.4455C14.9891 15.4264 14.9933 15.4071 14.9976 15.3878C15.0312 15.2345 15.0658 15.0768 15.109 14.9276C15.135 14.8375 15.1698 14.7501 15.213 14.6668V14.6624C15.2703 14.5587 15.3397 14.4621 15.4197 14.3748C15.5485 14.231 15.6856 14.095 15.8304 13.9673C15.9135 13.893 15.9971 13.8186 16.081 13.744C16.4507 13.415 16.8246 13.0822 17.1768 12.7385C17.4486 12.4662 17.6795 12.156 17.8626 11.8176ZM13.112 17.4892C13.3295 17.4008 13.5624 17.3565 13.7971 17.3591V17.3596C14.0304 17.3575 14.2618 17.402 14.4778 17.4903C14.6937 17.5787 14.8899 17.7092 15.0549 17.8742C15.4129 18.218 15.5921 18.6249 15.5925 19.0948C15.5928 19.5648 15.4137 19.9687 15.0549 20.3067C14.715 20.6315 14.2629 20.8128 13.7927 20.8128C13.3226 20.8128 12.8705 20.6315 12.5305 20.3067C12.1725 19.9695 11.9933 19.5655 11.993 19.0948C11.9926 18.6242 12.1718 18.2173 12.5305 17.8742C12.6969 17.7086 12.8945 17.5777 13.112 17.4892Z"
                  fill={Page === 10 ? "#fff" : "#fff"}
                />
              </svg>
            </ListItemIcon>
          </Tooltip>
          <ListItemText
            style={{ color: Page === 10 ? "#fff" : "#fff" }}
            primary={"Help"}
          />
        </ListItemButton>
        <ListItemButton
          key={"Support"}
          style={{
            display: DataUser.user.result.rol !== "admin" ? "none" : "",
          }}
          disabled={disablesPages("Support")}
          onClick={() => {
            HandlePage(12);
          }}
        >
          <Tooltip title="Support">
            <ListItemIcon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
              >
                <path
                  d="M15.4381 0.921875C12.6161 0.925662 9.88759 1.93368 7.74095 3.76549C5.59432 5.5973 4.1697 8.13331 3.72211 10.9196C3.62563 11.5276 0.69928 27.0779 0.69928 27.0779L9.40299 22.999C10.974 23.9272 12.7379 24.4804 14.5575 24.6158C16.3772 24.7511 18.2036 24.4649 19.8946 23.7794C21.5856 23.0938 23.0957 22.0274 24.3074 20.6632C25.5191 19.2989 26.3998 17.6735 26.8809 15.9134C27.3621 14.1533 27.4307 12.3059 27.0815 10.5149C26.7323 8.72398 25.9747 7.03771 24.8676 5.58726C23.7605 4.13681 22.3338 2.9613 20.6983 2.15213C19.0628 1.34297 17.2628 0.921968 15.4381 0.921875ZM14.8671 6.12956C15.1814 6.12969 15.4887 6.22304 15.75 6.39779C16.0113 6.57255 16.2149 6.82086 16.3351 7.11134C16.4553 7.40181 16.4866 7.7214 16.4252 8.02969C16.3637 8.33798 16.2122 8.62112 15.9898 8.84331C15.7675 9.06549 15.4842 9.21675 15.1758 9.27795C14.8675 9.33915 14.5479 9.30754 14.2576 9.18712C13.9672 9.06671 13.7191 8.86289 13.5445 8.60144C13.37 8.33999 13.2769 8.03266 13.277 7.7183C13.2769 7.50952 13.318 7.30277 13.3979 7.10988C13.4777 6.91699 13.5949 6.74175 13.7426 6.59418C13.8903 6.44661 14.0656 6.32962 14.2586 6.24989C14.4515 6.17017 14.6583 6.12928 14.8671 6.12956ZM17.1854 19.4633H13.5784C13.3638 19.4633 13.1581 19.3781 13.0064 19.2264C12.8547 19.0747 12.7695 18.869 12.7695 18.6544C12.7695 18.4399 12.8547 18.2342 13.0064 18.0825C13.1581 17.9308 13.3638 17.8455 13.5784 17.8455H14.0846V12.6101H13.9908C13.7545 12.6101 13.5268 12.5216 13.3525 12.362C13.1782 12.2024 13.0701 11.9833 13.0494 11.748C13.0286 11.5126 13.0968 11.278 13.2405 11.0904C13.3842 10.9028 13.5929 10.7758 13.8256 10.7345C13.8586 10.7279 14.8948 10.523 15.7104 10.3618C15.8288 10.3382 15.9509 10.3412 16.0681 10.3705C16.1852 10.3999 16.2943 10.4548 16.3876 10.5315C16.4809 10.6081 16.5561 10.7045 16.6076 10.8136C16.6592 10.9228 16.6859 11.042 16.6858 11.1628V17.8455H17.1854C17.4 17.8455 17.6057 17.9307 17.7574 18.0825C17.9091 18.2341 17.9943 18.4399 17.9943 18.6544C17.9943 18.869 17.9091 19.0747 17.7574 19.2264C17.6057 19.3781 17.4 19.4633 17.1854 19.4633L17.1854 19.4633Z"
                  fill={Page === 987 ? "#fff" : "#fff"}
                />
              </svg>
            </ListItemIcon>
          </Tooltip>
          <ListItemText
            style={{ color: Page === 987 ? "#fff" : "#fff" }}
            primary={"Support"}
          />
        </ListItemButton>
        <ListItemButton
          style={{ backgroundColor: Page === 15 ? "#544628" : "#090f1a" }}
          key={"About Us"}
          disabled={disablesPages("About")}
          onClick={() => {
            HandlePage(15);
          }}
        >
          <Tooltip title="About Us">
            <ListItemIcon>
              <svg
                width="24"
                height="19"
                viewBox="0 0 24 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M21 18.6677H2.33333C1.0856 18.7051 0.0424858 17.7266 0 16.4791V2.18857C0.042482 0.941179 1.0858 -0.0369288 2.33333 0.00107074H21C22.2475 -0.0369288 23.2909 0.941179 23.3333 2.18857V16.4802C23.2902 17.7273 22.2473 18.7051 21 18.6677ZM13.6857 12.5919C13.3364 12.8708 12.6962 13.2249 12.2298 13.192C11.7684 13.1595 11.8567 12.7196 11.9482 12.3738L12.7213 9.4505C12.8101 9.11488 12.7621 8.75775 12.5879 8.45744C12.4138 8.15713 12.1276 7.93815 11.7922 7.84853C11.4568 7.7589 11.0996 7.80595 10.7988 7.97936C10.4981 8.15276 10.2784 8.43836 10.1879 8.77353C10.075 9.19157 9.17167 12.9197 9.1661 12.943C9.03977 13.4727 8.88869 14.1497 9.1216 14.6718C9.47493 15.4637 10.548 15.2337 11.2 15.0452C11.6478 14.9176 12.0765 14.7303 12.4744 14.4885C12.9308 14.1772 13.3645 13.834 13.7723 13.4614L13.6857 12.5919ZM10.5648 4.81685C10.6026 3.81573 11.5692 2.94209 12.541 3.00301C13.8508 3.08511 14.5133 4.86006 13.5242 5.74941C12.7748 6.42323 11.3887 6.63583 10.7853 5.65957C10.6297 5.4068 10.553 5.11342 10.5648 4.81685Z"
                  fill={Page === 15 ? "#fff" : "#fff"}
                />
              </svg>
            </ListItemIcon>
          </Tooltip>
          <ListItemText
            style={{ color: Page === 15 ? "#fff" : "#fff" }}
            primary={"About Us"}
          />
        </ListItemButton>
        <ListItemButton
          key={"Exit"}
          onClick={() => {
            Logout();
          }}
        >
          <Tooltip title="Exit">
            <ListItemIcon>
              <ExitToApp style={{ fill: "#fff" }} />
            </ListItemIcon>
          </Tooltip>
          <ListItemText
            style={{ color: Page === 987 ? "#fff" : "#fff" }}
            primary={"Exit"}
          />
        </ListItemButton>
      </List>
    </ThemeProvider>
  );
}
